import React, { useState } from "react";
import "./useCasesSection.css";
import usecaseImage1 from "../../images/06 Financial Services.png";
import usecaseImage2 from "../../images/07 Healthcare.png";
import usecaseImage3 from "../../images/08 Retail.png";
import usecaseImage4 from "../../images/09 Manufacturing.png";
import ScrollReveal from "../scrollReveal/scrollReveal";

export default function UseCasesSection() {
  const [activeTab, setActiveTab] = useState(1);
  const tabContent = {
    1: {
      tabHeading: "Financial Services",
      content: [
        {
          heading: "Automated Audits for Compliance",
          paragraph:
            "Streamline regulatory audits with AI trust scores, reducing compliance costs and improving transparency. ",
        },
        {
          heading: "Fraud Detection with AI Trust ",
          paragraph:
            "Enhance fraud detection capabilities using trust scores and proactive risk management tools. ",
        },
        {
          heading: "Ethical Loan Approvals ",
          paragraph:
            "Ensure fair and ethical decision-making in loan approvals with AI guardrails. ",
        },
      ],
      image: usecaseImage1,
    },
    2: {
      tabHeading: "Healthcare",
      content: [
        {
          heading: "Ethical Patient Diagnosis",
          paragraph:
            "Deploy AI guardrails to ensure ethical and accurate decision-making in patient care.",
        },
        {
          heading: "AI-Assisted Drug Discovery",
          paragraph:
            "Accelerate drug development with quality-assured AI systems delivering reliable results.",
        },
        {
          heading: "Secure Medical Data Handling",
          paragraph:
            "Mitigate risks in managing sensitive medical data with automated compliance and security tools.",
        },
      ],
      image: usecaseImage2,
    },
    3: {
      tabHeading: "Retail",
      content: [
        {
          heading: "Personalized Shopping Experiences",
          paragraph:
            "Deliver AI-driven personalized shopping experiences with enhanced transparency and trust.",
        },
        {
          heading: "Inventory Risk Reduction",
          paragraph:
            "Optimize inventory management with predictive analytics and AI quality assurance.",
        },
        {
          heading: "Fraud Prevention in Transactions",
          paragraph:
            "Detect and prevent fraudulent activities with trust score-based monitoring systems.",
        },
      ],
      image: usecaseImage3,
    },
    4: {
      tabHeading: "Manufacturing",
      content: [
        {
          heading: "Optimized Supply Chain Operations",
          paragraph:
            "Streamline supply chain processes with AI risk management and quality assurance tools.",
        },
        {
          heading: "Defect-Free Production Assurance",
          paragraph:
            "Ensure consistent production quality through advanced AI-powered defect detection.",
        },
        {
          heading: "Workplace Safety Enhancement",
          paragraph:
            "Improve workplace safety with predictive risk assessment and real-time monitoring.",
        },
      ],
      image: usecaseImage4,
    },
    // 5: {
    //   tabHeading: "Telecommunications",
    //   content: [
    //     {
    //       heading: "Network Integrity Safeguarding",
    //       paragraph:
    //         "Secure network operations with proactive risk mitigation and AI-powered monitoring.",
    //     },
    //     {
    //       heading: "AI-Powered Customer Personalization",
    //       paragraph:
    //         "Enhance customer experiences with AI trust scores driving personalized services.",
    //     },
    //     {
    //       heading: "Service Downtime Reduction",
    //       paragraph:
    //         "Reduce service interruptions using predictive analytics and AI quality monitoring.",
    //     },
    //   ],
    //   image: usecaseImage1,
    // },
  };
  const handleTabSwitch = (index) => {
    setActiveTab(index);
  };

  return (
    <ScrollReveal>
      <section className="solution-section" id="one">
        <div className="container">
          <div className="section-wrapper">
            <div className="section-heading">
              <div className="heading-tag">
                <span>USE CASES</span>
              </div>
              <div className="heading-description">
                <div>
                  <h2>
                    Experience the Power of AI Trust and Assurance in Action
                  </h2>
                </div>
                <p>
                  Explore real-world use cases showcasing the impact of AI trust
                  and assurance in delivering secure, reliable, and ethical
                  solutions across industries
                </p>
              </div>
            </div>
            <div className="usecase-tab-switch-wrapper">
              <div className="tab-links-wrapper">
                {Object.keys(tabContent).map((key) => (
                  <div
                    key={key}
                    className={`${activeTab === parseInt(key) ? "active" : ""}`}
                    onClick={() => handleTabSwitch(parseInt(key))}
                  >
                    <p>{tabContent[key].tabHeading}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="usecase-tab-content-wrapper">
              <div className={`tab-content ${activeTab === 1 ? "active" : ""}`}>
                <div className="tab-content-left">
                  {tabContent[activeTab].content.map((item, index) => (
                    <div key={index} className="tab-content-section">
                      <h3>{item.heading}</h3>
                      <p>{item.paragraph}</p>
                    </div>
                  ))}
                </div>
                <div className="tab-content-right">
                  <img
                    src={tabContent[activeTab].image}
                    alt={tabContent[activeTab].content[0].heading}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
}
